
(function (root) {
  'use strict';
  var RULES=root.JPSDirectHitRules||(typeof require==='function'?require('./jps-direct-hit-finder-rules.js'):null);
  function setupText(key,values){return RULES?RULES.text(key,values):'JPS configuration review required.';}
  var CD = 0.894;
  var REF_PSI = 4060;
  var CHART = { '2.0': 2.0, '4.0': 4.0, '4.5': 4.6, '5.0': 5.0, '5.5': 5.6, '6.0': 6.1, '8.0': 8.0 };
  var JET_ID_MM = { '2.0': 0.85, '3.0': 1.05, '3.5': 1.15, '4.0': 1.25, '4.5': 1.30, '5.0': 1.40,
                    '5.5': 1.45, '6.0': 1.50, '8.0': 1.80, '10.0': 2.00, '12.0': 2.20 };
  var LIMITS = {
    minGpm: 0.5, maxGpm: 40,
    minPumpPsi: 2000,
    maxPumpPsi: 5075,
    minNozzlePsi: 1500,    // below this the hose is eating the pressure
    tolerance: 1,     // "at or below pump GPM"
    overMax: 1,
    penMinGpm: 5.5,        // Direct Hit's stated minimum for C38rs/C43rs (20 L/min)
    minHoseFt: 100,        // JPS: never size or suggest less than 100 ft of total hose
    goodNozzlePsi: 2500    // JPS: 2,500+ PSI at the nozzle is good cutting pressure
  };
  
  function pressureTarget(psi) { return Math.min(LIMITS.goodNozzlePsi, 0.9 * psi); }
  var PHONE = '(864) 804-6637';
  var PHONE_HREF = 'tel:8648046637';
  var SMALL_JETTER_URL = '/collections/1-4-inch-jetter-nozzles';
  var FITTINGS = {
    swivel: {
      '1/4': { variant: 54116086382960, code: '002-04-SS-SWIV-BSPP-NPT', part: '0030 0001', desc: '1/8" BSPP to 1/4" NPT swivel' },
      '3/8': { variant: 54116086350192, code: '002-06-SS-SWIV-BSPP-NPT', part: '0030 0002', desc: '1/8" BSPP to 3/8" NPT swivel' }
    },
    washer: { variant: 54116086710640, code: '002-SS-D-W', part: '0030 0003', desc: '1/8" Dowty washer' },
    rsAdapter: { variant: 67592693318000, handle: 'direct-hit-rs-3-8-to-1-4-npt-adapter', code: '006-04-SS-ADAP-MXF-NPT-DH', washer: '006-SS-D-W',
                 desc: 'Direct Hit 3/8" M x 1/4" F NPT adapter kit (006-04-SS-ADAP-MXF-NPT-DH + 006-SS-D-W washer)' }
  };
  var JIM_BANDS = { '4.5': [15 / 3.78541, 28 / 3.78541], '6.0': [28 / 3.78541, 36 / 3.78541] };

  var HOSE_IN = { '1/4"': 0.25, '3/8"': 0.375, '1/2"': 0.5, '5/8"': 0.625, '3/4"': 0.75, '1"': 1.0, '1-1/4"': 1.25 };
  function insertSet(m4) {
    return m4
      ? { '0.8': ['300-749-910', '0030 0056'], '0.9': ['300-749-911', '0030 0057'], '1.0': ['300-749-912', '0030 0058'] }
      : { '0.8': ['J-M6JET-08', '0030 0075'], '0.9': ['J-M6JET-09', '0030 0076'], '1.0': ['J-M6JET-1.0', '0030 0077'] };
  }
  var MODELS = {
    'C33RS':    { type: 'penetrator', name: 'C33RS Extra Short Penetrator', body: ['300-272-031', '0030 0020'], thread: 'M4', inserts: insertSet(true),  native: '1/4', sixJet: false },
    'C38RS':    { type: 'penetrator', name: 'C38RS Extreme Short Penetrator', body: ['300-330-341', '0030 0032'], thread: 'M6', inserts: insertSet(false), native: '3/8', sixJet: true },
    'C38RS HD': { type: 'penetrator', name: 'C38RS HD Penetrator', body: ['300-330-374', '0030 0033'], thread: 'M6', inserts: insertSet(false), native: '3/8', sixJet: true },
    'C43RS':    { type: 'penetrator', name: 'C43RS Short Penetrator', body: ['300-740-600', '0030 0054'], thread: 'M6', inserts: insertSet(false), native: '3/8', sixJet: true },
    'C43RS HD': { type: 'penetrator', name: 'C43RS HD Penetrator', body: ['300-740-622', '0030 0055'], thread: 'M6', inserts: insertSet(false), native: '3/8', sixJet: true },
    'C33DS30':  { type: 'cutter', name: 'C33DS30 Cutter', body: ['300-270-036', '0030 0018'], headWord: 'rotor kit',
                  heads: { '2.0': ['300-277-020', '0030 0023', true, 'Small-jetter 2.0 kit: JPS confirms with Direct Hit that it suits the C33 cutter before building.'],
                           '3.5': ['300-277-035', null, false], '4.0': ['300-277-040', '0030 0024', true], '4.5': ['300-277-045', '0030 0025', true],
                           '5.0': ['300-277-050', null, false], '5.5': ['300-277-055', null, false], '6.0': ['300-277-060', '0030 0026', true] } },
    'DC38':     { type: 'cutter', name: 'DC38 Extreme Cutter', body: ['300-337-010', '0030 0034'], headWord: 'rear head',
                  heads: { '2.0': [null, null, false], '3.0': ['300-324-030', null, false], '3.5': ['300-324-035', null, false], '4.0': ['300-324-040', null, false],
                           '4.5': ['300-324-045', '0030 0028', true], '5.0': ['300-324-050', null, false], '5.5': ['300-324-055', null, false] } },
    'DC43':     { type: 'cutter', name: 'DC43 Extreme Cutter', body: ['300-556-002', '0030 0042'], headWord: 'rear head',
                  heads: { '3.0': ['300-530-030', null, false], '3.5': ['300-530-035', null, false], '4.0': ['300-530-040', null, false], '4.5': ['300-530-045', '0030 0040', true],
                           '5.0': ['300-530-050', null, false], '5.5': ['300-530-055', null, false], '6.0': ['300-530-060', '0030 0041', true] } },
    'Hydro-X HD': { type: 'hydro', name: 'NDD / Hydro-X HD head', body: null, headWord: 'head',
                  heads: { '2.0': ['300-100-020', null, false], '3.0': ['300-100-030', null, false], '3.5': ['300-100-035', null, false],
                           '4.0': ['300-100-040', '0030 0007', true], '4.5': ['300-100-045', null, false], '5.0': ['300-100-050', '0030 0008', true],
                           '5.5': ['300-100-055', null, false], '6.0': ['300-100-060', '0030 0009', true], '8.0': ['300-100-080', '0030 0010', true],
                           '10.0': ['300-100-100', null, false], '12.0': ['300-100-120', null, false] } }
  };

  var PRODUCTS = {
    'direct-hit-c33rs-extra-short-penetrator':               { title: 'Direct Hit C33RS', models: ['C33RS'] },
    'direct-hit-c38rs-extreme-short-penetrator':             { title: 'Direct Hit C38RS', models: ['C38RS'] },
    'direct-hit-c38rs-hd-heavy-duty-penetrator':             { title: 'Direct Hit C38RS HD', models: ['C38RS HD'] },
    'direct-hit-c43rs-short-penetrator':                     { title: 'Direct Hit C43RS', models: ['C43RS'] },
    'direct-hit-c43rs-hd-heavy-duty-penetrator':             { title: 'Direct Hit C43RS HD', models: ['C43RS HD'] },
    'direct-hit-c33ds30-cutter':                             { title: 'Direct Hit C33DS30 Cutter', models: ['C33DS30'] },
    'direct-hit-dc38-extreme-cutter':                        { title: 'Direct Hit DC38 Cutter', models: ['DC38'] },
    'direct-hit-dc43-extreme-cutter':                        { title: 'Direct Hit DC43 Cutter', models: ['DC43'] },
    'direct-hit-combo-38-penetrator-cutter':                 { title: 'Direct Hit C38RS + DC38 Set', models: ['C38RS', 'DC38'] },
    'direct-hit-combo-43-penetrator-cutter':                 { title: 'Direct Hit C43RS + DC43 Set', models: ['C43RS', 'DC43'] },
    'direct-hit-ndd-hydrox-hd-hydro-excavation-nozzle-head': { title: 'Direct Hit Hydro-X HD Head', models: ['Hydro-X HD'] }
  };
  function orificeK(mm) { var d = mm / 25.4; return 29.83 * CD * d * d; }
  function headK(size) { return CHART[size] != null ? CHART[size] / Math.sqrt(REF_PSI) : orificeK(JET_ID_MM[size]); }
  function penK(insertMm, jets) { return headK('2.0') + jets * orificeK(parseFloat(insertMm)); }

  
  function hoseLossPsi(idIn, lengthFt, gpm) {
    if (!(idIn > 0) || !(lengthFt > 0) || !(gpm > 0)) return 0;
    var d = idIn * 0.0254, L = lengthFt * 0.3048, Q = gpm * 3.78541 / 60000, A = Math.PI * d * d / 4, v = Q / A;
    var Re = v * d / 1.0e-6, f;
    if (Re < 2300) f = 64 / Re;
    else if (Re < 1e5) f = 0.3164 / Math.pow(Re, 0.25);
    else { var x = -1.8 * Math.log10(6.9 / Re); f = 1 / (x * x); }
    return f * (L / d) * 1000 * v * v / 2 / 6894.757;
  }
  
  function hoseSections(input, idIn, ft) {
    if (input.hoses && input.hoses.length) {
      return input.hoses.map(function (h) { return [typeof h[0] === 'number' ? h[0] : normHoseId(h[0]), num(h[1])]; })
                        .filter(function (h) { return h[0] > 0 && h[1] > 0; });
    }
    if (idIn === undefined) { idIn = typeof input.hoseId === 'number' ? input.hoseId : normHoseId(input.hoseId); ft = num(input.hoseFt); }
    return idIn > 0 && ft > 0 ? [[idIn, ft]] : [];
  }
  function hoseLoss(sections, gpm) { return (sections || []).reduce(function (s, h) { return s + hoseLossPsi(h[0], h[1], gpm); }, 0); }
  
  function hoseCoeff(idIn, lengthFt, atGpm) { var g = atGpm || 8; return hoseLossPsi(idIn, lengthFt, g) / (g * g); }

  
  function operate(k, gpm, psi, sections) {
    var loss = typeof sections === 'number'
      ? function (g) { return sections * g * g; }                  // legacy constant coefficient (psi/gpm^2)
      : function (g) { return hoseLoss(sections, g); };
    var lo = 0, hi = k * Math.sqrt(psi);
    for (var i = 0; i < 60; i++) {
      var mid = (lo + hi) / 2, avail = psi - loss(mid);
      if (avail > 0 && mid < k * Math.sqrt(avail)) lo = mid; else hi = mid;
    }
    var q = lo;
    if (q <= gpm * LIMITS.tolerance) {
      return { fits: true, over: false, demand: q, flow: q, nozzlePsi: psi - loss(q), pumpPsi: psi, bypass: Math.max(0, gpm - q) };
    }
    var pn = Math.pow(gpm / k, 2), pp = pn + loss(gpm);   // pump can't hold pressure: it settles lower
    var near = false;
    return { fits: near, over: true, demand: q, flow: gpm, nozzlePsi: pn, pumpPsi: pp, bypass: 0, need: q };
  }
  function hoseTotal(input, idIn, ft) { return hoseSections(input, idIn, ft); }
  function num(v) { var n=Number(String(v==null?'':v).trim());return Number.isFinite(n)?n:NaN; }
  function normConn(s) {
    s = String(s || '').toLowerCase();
    if (!s) return '';
    if (/not\s*sure/.test(s)) return 'unsure';
    if (/1[-\s]+1\/4|1\.25/.test(s)) return 'other';
    if (s.indexOf('1/4') >= 0) return '1/4';
    if (s.indexOf('3/8') >= 0) return '3/8';
    return 'other';
  }
  function normHoseId(s) {
    s = String(s || '').trim();
    if (!s || /not\s*sure/i.test(s)) return 0;
    if (HOSE_IN[s] != null) return HOSE_IN[s];
    var t = s.replace(/["\s]|inch|in/gi, '');
    var map = { '1/4': 0.25, '3/8': 0.375, '1/2': 0.5, '5/8': 0.625, '3/4': 0.75, '1': 1, '1-1/4': 1.25 };
    if (map[t] != null) return map[t];
    var n = num(t); return n > 0 && n < 3 ? n : 0;
  }
  function fmt(n, d) { return Number(n).toLocaleString('en-US', { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); }

  function candidates(key) {
    var m = MODELS[key], list = [];
    if (m.type === 'penetrator') {
      Object.keys(m.inserts).forEach(function (mm) {
        var ins = m.inserts[mm];
        list.push({ label: '2.0 front rotor + 3 x ' + mm + ' mm rear inserts', short: '3 x ' + mm + ' mm', k: penK(mm, 3), stock: true,
                    parts: [[1, m.body[0], m.body[1], m.name + ' (factory 2.0 front)'], [3, ins[0], ins[1], m.thread + ' ceramic insert ' + mm + ' mm']] });
      });
      if (m.thread === 'M6') {
        ['1.1', '1.2', '1.3', '1.4', '1.5', '1.6'].forEach(function (mm, i) {
          list.push({ label: '2.0 front rotor + 3 x ' + mm + ' mm rear inserts', short: '3 x ' + mm + ' mm', k: penK(mm, 3), stock: false, code: '300-750-08' + (3 + i), parts: [] });
        });
      }
      if (m.sixJet) {
        Object.keys(m.inserts).forEach(function (mm) {
          list.push({ label: '2.0 front rotor + 6-jet carriage, 6 x ' + mm + ' mm', short: '6 x ' + mm + ' mm (6-jet)', k: penK(mm, 6), stock: false, code: '6-jet carriage', parts: [] });
        });
      }
    } else {
      Object.keys(m.heads).forEach(function (s) {
        var h = m.heads[s], parts = [];
        if (m.body) parts.push([1, m.body[0], m.body[1], m.name + ' body']);
        if (h[0]) parts.push([1, h[0], h[1], s + ' ' + m.headWord]);
        list.push({ label: s + ' ' + m.headWord, short: s, k: headK(s), stock: !!h[2], parts: parts, code: h[0], confirm: h[3] || null });
      });
    }
    return list;
  }

  
  function size(key,input){
    input=input||{};var m=MODELS[key],gpm=num(input.gpm),psi=num(input.psi),conn=normConn(input.connection);
    var r={model:key,name:m?m.name:key,type:m?m.type:'unknown',status:'review',headline:'',detail:[],build:null,notes:[],cart:[],input:{gpm:gpm,psi:psi,hoseId:input.hoseId,hoseFt:input.hoseFt,connection:conn}};
    if(!(gpm>0)||!(psi>0)||!conn)return block(r,setupText('missing_input'),'input');
    var check=RULES?RULES.classify(key,input):{status:'review',reason:'unknown_model'};
    r.status=check.status;r.reason=check.reason;
    r.headline=setupText(check.status==='block'?check.reason:'no_approved_build',{max:check.model&&check.model.absoluteMaxPsi});
    r.detail=RULES?RULES.describe(check,input):[setupText('unknown_model')];
    r.notes.push(setupText('request_note',{gpm:gpm,psi:psi}));
    if(check.status!=='block'&&conn!=='unsure')r.connection=setupText('connection_note',{connection:conn+' inch'});
    return r;
  }

  function connection(r, m, conn) {
    if (!conn) { r.status = 'block'; r.reason = 'connection'; r.headline = 'Choose your hose end size (1/4" or 3/8").'; return; }
    if (conn === 'other') { r.status = 'block'; r.reason = 'connection'; r.headline = 'Direct Hit nozzles are supplied for 1/4" or 3/8" hose ends only. Call ' + PHONE + ' for other sizes.'; return; }
    if (conn === 'unsure') { review(r, 'Hose end size not confirmed - JPS will confirm the fitting with you before shipping.'); r.connection = 'To be confirmed'; return; }
    if (m.type === 'cutter') {
      var sw = FITTINGS.swivel[conn];
      r.connection = sw.desc + ' + ' + FITTINGS.washer.desc;
      r.fittingParts = [[1, sw.code, sw.part, sw.desc], [1, FITTINGS.washer.code, FITTINGS.washer.part, FITTINGS.washer.desc]];
      r.cart.push({ id: sw.variant, qty: 1 }, { id: FITTINGS.washer.variant, qty: 1 });
    } else if (m.type === 'penetrator') {
      if (conn === m.native) r.connection = 'Native ' + conn + '" NPT inlet - no adapter needed';
      else if (m.native === '3/8') {
        var ad = FITTINGS.rsAdapter;
        r.connection = '1/4" hose: ' + ad.desc;
        r.fittingParts = [[1, ad.code, null, '3/8" M x 1/4" F NPT adapter'], [1, ad.washer, null, '3/8" Dowty washer']];
        r.cart.push({ id: ad.variant, qty: 1, handle: ad.handle, desc: ad.desc });
        review(r, '1/4" hose end: the Direct Hit adapter kit goes with your nozzle. JPS confirms the fit before shipping.');
      } else {
        r.connection = '3/8" hose: Direct Hit 3/8" expander fitting (JPS adds it and confirms before shipping)';
        review(r, '3/8" hose end: this nozzle needs a Direct Hit 3/8" expander. JPS adds it and confirms before shipping.');
      }
    } else {
      r.connection = conn + '" NPT - head-to-lance connection confirmed by JPS';
      review(r, 'Hydro-X head connection is confirmed with you before shipping.');
    }
  }
  function review(r, note) { if (r.status === 'ok') r.status = 'review'; r.notes.push(note); }
  function block(r, msg, reason) { r.status = 'block'; r.reason = reason; r.headline = msg; return r; }
  var HOSE_STEPS = [0.25, 0.375, 0.5, 0.625, 0.75, 1];
  var HOSE_NAME = { 0.25: '1/4"', 0.375: '3/8"', 0.5: '1/2"', 0.625: '5/8"', 0.75: '3/4"', 1: '1"' };
  function hoseName(id) { return HOSE_NAME[id] || (id + '"'); }
  function strength(nozzlePsi, psi) {
    var t = pressureTarget(psi);
    return { grade: nozzlePsi >= t - 0.5 ? 'strong' : nozzlePsi >= t - 500 ? 'fair' : 'weak', pct: nozzlePsi / psi };
  }
  function usable(r) { return r && r.build && (r.status !== 'block' || r.reason === 'hose'); }

  
  function advise(key, input, base) {
    base = base || size(key, input);
    var psi = num(input.gpm) > 0 ? num(input.psi) : NaN;
    if (!usable(base) || !(psi > 0)) return [];
    var now = strength(base.build.nozzlePsi, psi);
    if (now.grade === 'strong' && base.status !== 'block') return [];
    var hoses = base.hoses || [];
    var out = [];
    function tryIt(kind, text, inp) {
      var r = size(key, inp);
      if (!usable(r) || r.status === 'block') return null;
      var s = strength(r.build.nozzlePsi, psi);
      if (r.build.nozzlePsi < base.build.nozzlePsi + 150) return null;   // not a meaningful gain
      return { kind: kind, text: text, nozzlePsi: r.build.nozzlePsi, grade: s.grade, pct: s.pct, build: r.build };
    }
    function withHoses(h) { var c = {}; Object.keys(input).forEach(function (k) { c[k] = input[k]; }); c.hoses = h; delete c.hoseId; delete c.hoseFt; return c; }
    var totalFt = hoses.reduce(function (s, x) { return s + x[1]; }, 0);
    hoses.forEach(function (h, i) {
      var pick = null;
      for (var L = Math.floor((h[1] - 25) / 25) * 25; L >= 25; L -= 25) {
        if (totalFt - h[1] + L < LIMITS.minHoseFt) break;
        var hs = hoses.map(function (x, j) { return j === i ? [x[0], L] : x; });
        var t = tryIt('shorter', 'Use ' + L + ' ft of ' + hoseName(h[0]) + ' hose instead of ' + fmt(h[1]) + ' ft', withHoses(hs));
        if (t) { if (!pick || t.grade === 'strong' || t.nozzlePsi > pick.nozzlePsi) pick = t; if (t.grade === 'strong') break; }
      }
      if (pick) out.push(pick);
    });
    hoses.forEach(function (h, i) {
      var k = HOSE_STEPS.indexOf(h[0]); if (k < 0 || k === HOSE_STEPS.length - 1) return;
      var up = HOSE_STEPS[k + 1];
      var hs = hoses.map(function (x, j) { return j === i ? [up, x[1]] : x; });
      var t = tryIt('bigger', 'Use ' + hoseName(up) + ' hose instead of ' + hoseName(h[0]) + ' for the ' + fmt(h[1]) + ' ft section', withHoses(hs));
      if (t) out.push(t);
    });
    if (base.options) {
      var chosenK = null;
      base.options.forEach(function (o) { if (o.label === base.build.label) chosenK = o.k; });
      base.options.filter(function (o) { return o.stock && chosenK !== null && o.k < chosenK && o.op.fits && !o.op.over; })
        .sort(function (a, b) { return b.k - a.k; })
        .some(function (o) {
          var s = strength(o.op.nozzlePsi, psi);
          if (o.op.nozzlePsi < base.build.nozzlePsi + 150) return false;
          out.push({ kind: 'smaller', text: 'Run a smaller setup: ' + o.label + ' (uses ' + fmt(o.op.flow, 1) + ' GPM, the rest bypasses)',
                     nozzlePsi: o.op.nozzlePsi, grade: s.grade, pct: s.pct, build: { label: o.label, short: o.short, parts: o.parts, flow: o.op.flow, nozzlePsi: o.op.nozzlePsi } });
          return s.grade === 'strong';
        });
    }
    var rank = { strong: 0, fair: 1, weak: 2 };
    out.sort(function (a, b) { return rank[a.grade] - rank[b.grade] || b.nozzlePsi - a.nozzlePsi; });
    var seen = {}, res = [];
    out.forEach(function (x) { if (!seen[x.kind] && res.length < 3) { seen[x.kind] = 1; res.push(x); } });
    return res;
  }
  function pressureLine(r, psi) {
    if (!usable(r)) return '';
    var s = strength(r.build.nozzlePsi, psi);
    return 'Pressure at the nozzle: about ' + fmt(r.build.nozzlePsi) + ' PSI (' + fmt(s.pct * 100) + '% of your ' + fmt(psi) + ' PSI) - ' +
           (s.grade === 'strong' ? 'strong cutting pressure.' : s.grade === 'fair' ? 'fair; it will cut, but 2,500+ PSI cuts better.' : 'weak; too much of your pressure is lost in the hose.');
  }

  
  function sizeProduct(handle, input) {
    var p = PRODUCTS[handle];
    if (!p) return null;
    var parts = p.models.map(function (k) {
      var r = size(k, input);
      if (usable(r)) { r.strength = strength(r.build.nozzlePsi, num(input.psi)); r.pressureLine = pressureLine(r, num(input.psi)); r.advice = advise(k, input, r); }
      return r;
    });
    var rank = { ok: 0, review: 1, block: 2 };
    var worst = parts.reduce(function (a, b) { return rank[b.status] > rank[a.status] ? b : a; });
    var cart = [];
    parts.forEach(function (x) { if (x.status !== 'block') cart = cart.concat(x.cart); });
    var g = { strong: 0, fair: 1, weak: 2 }, pg = null;
    parts.forEach(function (x) { if (x.strength && x.status !== 'block' && (pg === null || g[x.strength.grade] > g[pg])) pg = x.strength.grade; });
    return { handle: handle, title: p.title, status: worst.status, parts: parts, cart: cart, pressureGrade: pg };
  }

  
  function lineProperties(res) {
    var props = {};
    res.parts.forEach(function (x) {
      var tag = res.parts.length > 1 ? ' - ' + x.model : '';
      if (!x.build) return;
      props['Direct Hit Build' + tag] = x.build.label;
      props['Build Parts' + tag] = x.build.parts.map(function (p) { return p[0] + ' x ' + p[1] + (p[2] ? ' [' + p[2] + ']' : ''); }).join('; ');
      props['Calculated' + tag] = fmt(x.build.flow, 1) + ' GPM (' + fmt(x.build.pct * 100) + '% of pump) at ' + fmt(x.build.nozzlePsi) + ' PSI at nozzle' +
        (x.build.over ? '; jetter settles at ~' + fmt(x.build.pumpPsi) + ' PSI' : '');
      if (x.connection) props['Connection' + tag] = x.connection;
      if (x.notes.length) props['Build Notes' + tag] = x.notes.join(' ');
      if (x.strength) props['Nozzle Pressure' + tag] = fmt(x.build.nozzlePsi) + ' PSI (' + x.strength.grade + ')';
      if (x.advice && x.advice.length) props['To Raise Pressure' + tag] = x.advice.map(function (a) { return a.text + ' -> ~' + fmt(a.nozzlePsi) + ' PSI'; }).join(' | ');
    });
    props._dh_jetting_status = res.status;
    props._dh_jetting_version = '2026-10-05-review-only';
    return props;
  }

  var engine = {
    CD: CD, LIMITS: LIMITS, MODELS: MODELS, PRODUCTS: PRODUCTS, FITTINGS: FITTINGS,
    headK: headK, penK: penK, orificeK: orificeK, hoseCoeff: hoseCoeff, hoseTotal: hoseTotal, operate: operate,
    hoseLossPsi: hoseLossPsi, hoseLoss: hoseLoss, hoseSections: hoseSections,
    advise: advise, strength: strength, pressureLine: pressureLine,
    size: size, sizeProduct: sizeProduct, lineProperties: lineProperties, candidates: candidates,
    normConn: normConn, normHoseId: normHoseId, fmt: fmt, PHONE: PHONE, SMALL_JETTER_URL: SMALL_JETTER_URL
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = engine; return; }
  root.JPSDirectHit = engine;
  var doc = root.document;
  if (!doc) return;

  function el(tag, attrs, html) {
    var e = doc.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (a) { e.setAttribute(a, attrs[a]); });
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function injectCss() {
    if (doc.getElementById('dhj-css')) return;
    var css = '' +
      '.dhj-panel{margin:12px 0;padding:14px 16px;border-radius:10px;border:2px solid #cbd5e1;background:#f8fafc;font-size:15px;line-height:1.45}' +
      '.dhj-panel h4{margin:0 0 6px;font-size:16px}' +
      '.dhj-panel ul{margin:6px 0 0 18px;padding:0}' +
      '.dhj-ok{border-color:#16a34a;background:#f0fdf4}.dhj-review{border-color:#d97706;background:#fffbeb}.dhj-block{border-color:#dc2626;background:#fef2f2}' +
      '.dhj-badge{display:inline-block;font-size:12px;font-weight:700;padding:2px 8px;border-radius:99px;margin-right:6px;color:#fff}' +
      '.dhj-ok .dhj-badge,.dhj-b-ok{background:#16a34a}.dhj-review .dhj-badge,.dhj-b-review{background:#d97706}.dhj-block .dhj-badge,.dhj-b-block{background:#dc2626}' +
      '.dhj-note{color:#475569;font-size:13px;margin-top:6px}' +
      '.dhj-finder{border:1px solid #cbd5e1;border-radius:12px;padding:18px;margin:18px 0;background:#fff}' +
      '.dhj-finder h3{margin:0 0 4px}.dhj-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:10px;margin:12px 0}' +
      '.dhj-grid label{display:flex;flex-direction:column;font-size:13px;font-weight:600;gap:4px}' +
      '.dhj-grid input,.dhj-grid select{padding:9px;border:1px solid #94a3b8;border-radius:8px;font-size:15px}' +
      '.dhj-results{display:grid;gap:8px}.dhj-row{display:flex;flex-wrap:wrap;gap:6px 12px;align-items:baseline;justify-content:space-between;border:1px solid #e2e8f0;border-radius:10px;padding:10px 12px}' +
      '.dhj-row b{font-size:15px}.dhj-row .dhj-why{flex-basis:100%;font-size:13px;color:#334155}.dhj-row a{font-weight:700;white-space:nowrap}' +
      '.dhj-req-star{color:#dc2626}' +
      '#dhjOthers .dhj-others{margin:18px 0 0;border:1px solid #d6dee8;border-radius:10px;background:#fff}' +
      '#dhjOthers summary{cursor:pointer;list-style:none;display:flex;align-items:center;justify-content:space-between;gap:10px;min-height:48px;padding:12px 16px;font-size:15px;font-weight:800;color:#0f2542}' +
      '#dhjOthers summary::-webkit-details-marker{display:none}#dhjOthers summary:after{content:"+";font-size:22px;line-height:1;color:#2458be}' +
      '#dhjOthers details[open] summary:after{content:"−"}#dhjOthers details[open] summary{border-bottom:1px solid #e3e9f1}' +
      '#dhjOthers .dhj-cards,#dhjOthers .dhj-note{padding:12px 16px 16px}' +
      '.dhj-others{margin:14px 0}.dhj-others h4{margin:0 0 8px;font-size:16px}' +
      '.dhj-cards{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:12px}' +
      '.dhj-card{display:flex;flex-direction:column;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;background:#fff;color:inherit;text-decoration:none;transition:box-shadow .15s,border-color .15s}' +
      '.dhj-card:hover,.dhj-card:focus-visible{border-color:#0a1c3a;box-shadow:0 4px 14px rgba(10,28,58,.12)}' +
      '.dhj-c-img{display:flex;align-items:center;justify-content:center;background:#f8fafc;aspect-ratio:4/3;padding:8px}' +
      '.dhj-c-img img{max-width:100%;max-height:100%;object-fit:contain}.dhj-c-noimg{font-weight:800;color:#94a3b8}' +
      '.dhj-c-body{display:flex;flex-direction:column;gap:5px;padding:10px 12px 12px;font-size:13px;line-height:1.4;flex:1}' +
      '.dhj-c-title{font-weight:800;font-size:14px;line-height:1.25}.dhj-c-price{font-weight:800;font-size:15px}' +
      '.dhj-c-build{margin:0;padding:0 0 0 16px}.dhj-c-flow{color:#64748b}' +
      '.dhj-c-grade{font-weight:700;font-size:12px;padding:3px 8px;border-radius:99px;align-self:flex-start}' +
      '.dhj-g-strong{background:#dcfce7;color:#166534}.dhj-g-fair{background:#fef3c7;color:#92400e}.dhj-g-weak{background:#fee2e2;color:#991b1b}' +
      '.dhj-c-note{color:#64748b;font-size:12px}.dhj-c-cta{margin-top:auto;padding-top:4px;font-weight:800;color:#0a1c3a}' +
      '.dhj-f-head{font-weight:800;font-size:16px;margin:4px 0 8px}' +
      '@media (max-width:600px){' +
        '.dhj-panel{padding:12px;font-size:14px}.dhj-panel h4{font-size:15px}' +
        '.dhj-finder{padding:14px;margin:12px 0}.dhj-finder h3{font-size:18px}' +
        '.dhj-grid{grid-template-columns:1fr 1fr;gap:8px}.dhj-grid input,.dhj-grid select{font-size:16px;padding:10px 8px;min-width:0;width:100%}' +
        '.dhj-cards{grid-template-columns:1fr;gap:8px}' +
        '.dhj-card{flex-direction:row;align-items:stretch}' +
        '.dhj-c-img{flex:0 0 88px;width:88px;aspect-ratio:auto;padding:6px}' +
        '.dhj-c-img img{width:76px;height:76px;max-height:76px;object-fit:contain}' +
        '.dhj-c-body{padding:8px 10px;gap:3px;min-width:0}' +
        '.dhj-c-title{font-size:13.5px}.dhj-c-price{font-size:14px}.dhj-c-grade{font-size:11.5px}' +
        '.dhj-c-cta{margin-top:4px;padding-top:0}' +
      '}' +
      '.dhj-psi{margin-top:6px;font-weight:600}.dhj-psi-strong{color:#15803d}.dhj-psi-fair{color:#b45309}.dhj-psi-weak{color:#b91c1c}';
    doc.head.appendChild(el('style', { id: 'dhj-css' }, css));
  }

  function panelHtml(res) {
    var weakP = res.status !== 'block' && res.pressureGrade === 'weak';
    var cls = res.status === 'block' ? 'dhj-block' : (res.status === 'review' || weakP) ? 'dhj-review' : 'dhj-ok';
    var badge = setupText(res.status==='block'?'blocked_badge':'review_badge');
    var html = '<div class="dhj-panel ' + cls + '" role="status"><h4><span class="dhj-badge">' + badge + '</span>'+esc(setupText('product_title'))+'</h4>';
    res.parts.forEach(function (x) {
      if (res.parts.length > 1) html += '<div style="margin-top:8px"><b>' + esc(x.model) + '</b></div>';
      html += '<div>' + esc(x.headline) + '</div>';
      if (x.detail.length) html += '<ul>' + x.detail.map(function (d) { return '<li>' + esc(d) + '</li>'; }).join('') + '</ul>';
      if (x.pressureLine) html += '<div class="dhj-psi dhj-psi-' + x.strength.grade + '">' + esc(x.pressureLine) + '</div>';
      if (x.advice && x.advice.length) {
        html += '<div class="dhj-note"><b>To get more cutting pressure:</b><ul>' + x.advice.map(function (a) {
          return '<li>' + esc(a.text) + ' - about <b>' + fmt(a.nozzlePsi) + ' PSI</b> at the nozzle' + (a.build && a.build.label !== (x.build && x.build.label) ? ' (' + esc(a.build.label) + ')' : '') + '.</li>';
        }).join('') + '</ul></div>';
      }
      if (x.connection && x.status !== 'block') {
        var liveFit = x.cart.filter(fittingLive).length, heldFit = x.cart.length - liveFit;
        html += '<div class="dhj-note">Connection: ' + esc(x.connection) + (liveFit ? ' (added to your cart with the nozzle)' : heldFit ? ' (JPS adds it to your order)' : '') + '</div>';
      }
      x.notes.forEach(function (n) { html += '<div class="dhj-note">' + esc(n) + '</div>'; });
    });
    if (res.status === 'block') html += '<div class="dhj-note"><a href="' + PHONE_HREF + '">Call ' + PHONE + '</a> - we will set you up with the right nozzle.</div>';
    return html + '</div>';
  }
  var INFO = null;
  function info(handle) {
    if (!INFO) {
      INFO = {};
      var d = doc.getElementById('dh-products');
      if (d) { try { INFO = JSON.parse(d.textContent) || {}; } catch (e) { INFO = {}; } }
    }
    var i = INFO[handle] || {};
    return { title: i.title || PRODUCTS[handle].title, url: i.url || '/products/' + handle, price: i.price, image: i.image || null, available: i.available === true };
  }
  
  function fittingLive(c) {
    if (!c.handle) return true;
    info(Object.keys(PRODUCTS)[0]);   // loads INFO
    var i = INFO && INFO[c.handle];
    return !!(i && i.available !== false);
  }
  function money(cents) { return cents == null ? '' : '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function setupQs(inp) {
    return '?jps_setup=1&jps_gpm='+encodeURIComponent(inp.gpm||'')+'&jps_psi='+encodeURIComponent(inp.psi||'')+'&jps_connection='+encodeURIComponent(inp.connection||'')+'&jps_hose='+encodeURIComponent(inp.hoseId||'')+'&jps_length='+encodeURIComponent(inp.hoseFt||'');
  }
  var GRADE_TEXT = { strong: 'Strong cutting pressure', fair: 'Fair pressure', weak: 'Low pressure' };
  
  function cardHtml(r,inp){
    var p=info(r.handle),model=RULES&&RULES.find(r.handle),check=RULES&&RULES.classify(r.handle,inp),notes=check?RULES.describe(check,inp):[setupText('unknown_model')];
    var img=p.image?'<img src="'+esc(p.image)+'" alt="'+esc(p.title)+'" loading="lazy" width="180" height="180">':'<span class="dhj-c-noimg">Direct Hit</span>';
    var role=model&&model.kind==='rs_penetrator'?'rs_role':model&&model.kind==='two_tool_set'?'combo_role':model&&model.kind==='hydro'?'hydro_role':'dc_role';
    return '<a class="dhj-card" href="'+esc(p.url+setupQs(inp))+'"><span class="dhj-c-img">'+img+'</span><span class="dhj-c-body"><span class="dhj-c-title">'+esc(p.title)+'</span>'+(p.price!=null?'<span class="dhj-c-price">'+money(p.price)+'</span>':'')+'<span class="dhj-c-note">'+esc(setupText(role))+'</span><span class="dhj-c-grade dhj-g-fair">'+esc(setupText('review_badge'))+'</span><span class="dhj-c-note">'+esc(notes.join(' '))+'</span><span class="dhj-c-cta">'+esc(setupText('cta'))+'</span></span></a>';
  }

  
  function fittingProducts(inp, skip) {
    var g = { strong: 0, fair: 1, weak: 2 };
    var all = Object.keys(PRODUCTS).filter(function (h) { return h !== skip && (!RULES||RULES.find(h)&&RULES.find(h).drain); }).map(function (h) { return sizeProduct(h, inp); });
    var fits = all.filter(function (r) { return r.status !== 'block' && info(r.handle).available; })
      .sort(function(a,b){return RULES.classify(a.handle,inp).advisoryRank-RULES.classify(b.handle,inp).advisoryRank;});
    var special = all.filter(function (r) { return r.status === 'block' && r.parts.some(function (x) { return x.reason === 'special'; }) && r.parts.every(function (x) { return x.status !== 'block' || x.reason === 'special'; }); });
    return { fits: fits, special: special };
  }

  
  function otherFitsHtml(current,inp){
    if(!(num(inp.gpm)>0)||!(num(inp.psi)>0)||!normConn(inp.connection))return '';
    var res=fittingProducts(inp,current);
    return '<details class="dhj-others"><summary>'+esc(setupText('others'))+' ('+res.fits.length+')</summary>'+(res.fits.length?'<div class="dhj-cards">'+res.fits.map(function(r){return cardHtml(r,inp);}).join('')+'</div>':'<div class="dhj-note">'+esc(setupText('no_options'))+'</div>')+'</details>';
  }
  function readInputs() {
    function v(id) { var e = doc.getElementById(id); return e ? (e.value || '').trim() : ''; }
    return { gpm: v('jsGpm'), psi: v('jsPsi'), hoseId: v('jsHose'), hoseFt: v('jsLength'), connection: v('jsConnection') };
  }

  function initProduct(handle) {
    var btn = doc.getElementById('pdpAdd');
    var gpmEl = doc.getElementById('jsGpm');
    if (!btn || !gpmEl || !PRODUCTS[handle]) return;
    injectCss();
    btn.setAttribute('data-hose', '');
    btn.setAttribute('data-requires-psi', '1');

    var grid = gpmEl.closest('.js-grid');
    if (!doc.getElementById('jsPsi')) {
      var lab = el('label', { class: 'js-req' }, '<span>Jetter pressure (PSI) <span class="dhj-req-star">*</span></span>');
      var psi = el('input', { type: 'number', id: 'jsPsi', min: '1', max: '10000', step: '1', inputmode: 'numeric', placeholder: 'e.g. 4000', required: 'required',
                              'data-limit-message': setupText('missing_input') });
      lab.appendChild(psi); grid.appendChild(lab);
    }
    [['jsConnection', '<span>Hose end size <span class="dhj-req-star">*</span></span>'], ['jsHose', '<span>Hose inside diameter</span>'], ['jsLength', '<span>Hose length (ft)</span>']].forEach(function (f) {
      var e = doc.getElementById(f[0]); if (!e) return;
      var l = e.closest('label'); if (!l) return;
      l.innerHTML = f[1]; l.appendChild(e); grid.appendChild(l);
    });
    var conn = doc.getElementById('jsConnection');
    if (conn) {
      Array.prototype.slice.call(conn.options).forEach(function (o) { if (o.value && !/1\/4 inch|3\/8 inch|not sure/i.test(o.value + o.text) || /1-1\/4/.test(o.text)) o.remove(); });
      conn.setAttribute('required', 'required');
    }
    var summary = doc.querySelector('#jetterSetup summary .js-txt b');
    if (summary) summary.textContent = setupText('product_required');

    var panel = el('div', { id: 'dhjPanel', 'aria-live': 'polite' });
    grid.parentNode.insertBefore(panel, grid.nextSibling);
    var others = el('div', { id: 'dhjOthers', 'aria-live': 'polite' });
    var buybox = btn.closest('.buybox');
    if (buybox && buybox.parentNode) buybox.parentNode.insertBefore(others, buybox.nextSibling);
    else panel.parentNode.insertBefore(others, panel.nextSibling);
    try {
      var q = new URLSearchParams(root.location.search);
      [['gpm', 'jsGpm'], ['psi', 'jsPsi'], ['hose', 'jsHose'], ['len', 'jsLength'], ['conn', 'jsConnection']].forEach(function (p) {
        var aliases={gpm:'jps_gpm',psi:'jps_psi',hose:'jps_hose',len:'jps_length',conn:'jps_connection'};var v=q.get(aliases[p[0]])||q.get(p[0]),e=doc.getElementById(p[1]);if(v&&e)e.value=v;
      });
    } catch (e) {  }

    var touched = false;
    function render(force) {
      var inp = readInputs();
      if (!force && !touched && !inp.gpm) { panel.innerHTML = ''; others.innerHTML = ''; return null; }
      var res = sizeProduct(handle, inp);
      panel.innerHTML = panelHtml(res);
      var wasOpen = !!others.querySelector('details[open]');
      others.innerHTML = otherFitsHtml(handle, inp);
      if (wasOpen && others.firstChild) others.firstChild.open = true;
      return res;
    }
    ['jsGpm', 'jsPsi', 'jsHose', 'jsLength', 'jsConnection'].forEach(function (id) {
      var e = doc.getElementById(id); if (!e) return;
      e.addEventListener('input', function () { touched = true; render(); });
      e.addEventListener('change', function () { touched = true; render(); });
    });
    render();
    doc.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('#pdpAdd, .mobile-atc');
      if (!b) return;
      ev.preventDefault(); ev.stopImmediatePropagation();
      touched = true;
      var res = render(true);
      var setup = doc.getElementById('jetterSetup'); if (setup) setup.open = true;
      if (!res || res.status === 'block') { panel.scrollIntoView && panel.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (btn.disabled || btn.dataset.cartPending === "true" || btn.dataset.cartUncertain === "true") return;
      var consent=doc.getElementById('jsBackorderConsent');if(btn.getAttribute('data-backorder')==='1'&&(!consent||!consent.checked)){if(consent){consent.reportValidity();consent.focus();}return;}
      var qtyEl = doc.getElementById('qty'); var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
      var props = collectProps(res);
      var held = res.cart.filter(function (c) { return !fittingLive(c); });
      if (held.length) props['Adapter needed'] = held.map(function (c) { return c.desc; }).join('; ') + ' - JPS to add before shipping';
      var fittings = res.cart.filter(fittingLive).map(function (c) { return { id: c.id, quantity: c.qty * qty, properties: { 'For': res.title } }; });
      btn.disabled = true;
      btn.dataset.cartPending = "true";
      doc.dispatchEvent(new Event("jps:purchase-state"));
      var vid = btn.getAttribute('data-add');
      var items = [{ id: Number(vid), quantity: qty, properties: props }].concat(fittings);
      var operation = typeof root.JPS_addItems === 'function'
        ? root.JPS_addItems(items)
        : Promise.resolve({status:'rejected',reason:'unavailable'});
      operation.catch(function(){return {status:'uncertain'};}).then(function(result){
        btn.dataset.cartPending = "false";
        btn.dataset.cartUncertain = result.status === 'uncertain' ? "true" : "false";
        btn.disabled = result.status === 'uncertain' || btn.dataset.variantAvailable === "false";
        if(result.status !== 'added'){
          panel.innerHTML = '<div class="dhj-panel dhj-block">' + (result.status === 'uncertain' ? ((root.JPS_TEXT && root.JPS_TEXT.cart_locked) || 'Review your cart before adding this item again.') : ((root.JPS_TEXT && root.JPS_TEXT.cart_add_rejected) || 'This item could not be added.')) + '</div>';
        }
        doc.dispatchEvent(new Event("jps:purchase-state"));
      });
    }, true);
  }

  function collectProps(res) {
    var map = [['jsGpm', 'Jetter Flow (GPM)'], ['jsPsi', 'Jetter Pressure (PSI)'], ['jsHose', 'Hose ID'], ['jsConnection', 'Hose Connection'],
               ['jsLength', 'Hose Length (ft)'], ['jsApp', 'Application'], ['jsMachine', 'Machine Make/Model'], ['jsNotes', 'Pipe Size / Notes']];
    var props = {};
    map.forEach(function (m) { var e = doc.getElementById(m[0]); var v = e ? (e.value || '').trim() : ''; if (v) props[m[1]] = v; });
    var b = lineProperties(res);
    Object.keys(b).forEach(function (k) { props[k] = b[k]; });
    props.Configuration = setupText('configuration');
    props._jps_configuration_review = 'required';
    return props;
  }
  function initFinder(box) {
    injectCss();
    box.classList.add('dhj-finder');
    box.innerHTML =
      '<h3>'+esc(setupText('heading'))+'</h3>' +
      '<div>'+esc(setupText('collection_intro'))+'</div>' +
      '<div class="dhj-grid">' +
      '<label>Flow (GPM) *<input id="dhfGpm" type="number" step="0.1" min="0.5" inputmode="decimal" placeholder="e.g. 8"></label>' +
      '<label>Pressure (PSI) *<input id="dhfPsi" type="number" step="1" min="1" inputmode="numeric" placeholder="e.g. 4000"></label>' +
      '<label>Hose end size *<select id="dhfConn"><option value="">Select...</option><option>1/4 inch</option><option>3/8 inch</option><option>Not sure</option></select></label>' +
      '<label>Hose inside diameter<select id="dhfHose"><option value="">Not sure</option><option>1/4"</option><option>3/8"</option><option>1/2"</option><option>5/8"</option><option>3/4"</option><option>1"</option></select></label>' +
      '<label>Hose length (ft)<input id="dhfLen" type="number" step="1" min="1" inputmode="numeric" placeholder="e.g. 200"></label>' +
      '</div><div class="dhj-results" id="dhfResults"></div>';
    function v(id) { return (doc.getElementById(id).value || '').trim(); }
    function run() {
      var inp = { gpm: v('dhfGpm'), psi: v('dhfPsi'), connection: v('dhfConn'), hoseId: v('dhfHose'), hoseFt: v('dhfLen') };
      var out = doc.getElementById('dhfResults');
      if (!inp.gpm || !inp.psi) { out.innerHTML = '<div class="dhj-note">Enter GPM and PSI to see your options.</div>'; return; }
      if (!normConn(inp.connection)) { out.innerHTML = '<div class="dhj-note">Choose your hose end size to compare available configurations.</div>'; return; }
      var html = '';
      var res = fittingProducts(inp, null);
      if(!res.fits.length){html+='<div class="dhj-panel dhj-review">'+esc(setupText('no_options'))+'</div>';}
      else{html+='<div class="dhj-f-head">'+res.fits.length+' '+esc(setupText('options_count'))+'</div><div class="dhj-cards">'+res.fits.map(function(r){return cardHtml(r,inp);}).join('')+'</div>';}
      out.innerHTML = html;
    }
    ['dhfGpm', 'dhfPsi', 'dhfConn', 'dhfHose', 'dhfLen'].forEach(function (id) {
      var e = doc.getElementById(id); e.addEventListener('input', run); e.addEventListener('change', run);
    });
  }

  function boot() {
    var cfg = doc.getElementById('dh-jetting-config');
    var handle = null;
    if (cfg) { try { handle = JSON.parse(cfg.textContent).handle; } catch (e) { handle = null; } }
    if (!handle) { var m = root.location.pathname.match(/\/products\/([^/?#]+)/); handle = m && m[1]; }
    if (handle && PRODUCTS[handle]) initProduct(handle);
    var f = doc.getElementById('dh-jetting-finder');
    if (f) {
      var layout = doc.querySelector('.shop-layout');
      if (layout && !layout.contains(f) && f.compareDocumentPosition(layout) & 2) {
        var wrap = doc.createElement('div'); wrap.className = 'wrap';
        wrap.appendChild(f); layout.parentNode.insertBefore(wrap, layout);
      }
      initFinder(f);
    }
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})(typeof window !== 'undefined' ? window : this);